// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2tPgn","title":"Info_title__1wsKr","links":"Info_links__KFiW9","link":"Info_link__3GNR2","logo":"Info_logo__2C0iC"};